import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../../nodeInstance";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { useState } from "react";

export default function IdlePopUp_New({
  cancelOpen,
  setCancelOpen,
  setPopUp,
  popUpData,
  trigger,
  setTrigger,
  routeType,
  issuedState,
  showDate,
}) {
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState("");

  const handleChangeDate = (e) => {
    setSelectedDate(e.target.value);
  };

  const cancelRequest = async () => {
    if (showDate && !issuedState && selectedDate === "") {
      dispatch(
        setAppError({
          msg: "Date is required.",
        })
      );
      return;
    }
    let reqObj;
    if (showDate) {
      reqObj = {
        returnere: selectedDate,
      };
    }
    reqObj = {
      employee_id: popUpData?.candidate_id,
      demobilization_type: "IDLE",
    };
    const endPoint =
      routeType === "Emergency_leave"
        ? `/ere/cancelRequest`
        : routeType === "Annual_Vacation"
          ? "/employeeAnnualvacation/cancelRequestAnnual"
          : "";
    try {
      const response = await nodeinstance.put(`${endPoint}`, reqObj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setPopUp(false);
        setCancelOpen(false);
        setTrigger(!trigger);
        dispatch(
          setAppError({
            msg: "Updated successfully...",
            color: "success",
          })
        );
        return;
      }
    } catch (error) {
      console.log("error.......", error);
      dispatch(
        setAppError({
          msg: "Failed to cancel the request",
        })
      );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          cancelOpen ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-2xl max-h-[45rem]  w-full h-auto mt-4 rounded-md overflow-scroll bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setCancelOpen(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div>
            <h2>Are you sure, Do you want to make this employee as idle ? </h2>
          </div>
          {showDate && !issuedState ? (
            <div className="flex align-center mt-4">
              <p>ERE RETURN DATE : </p>
              <input
                type="date"
                className={`input input-xl h-8 max-w-xl input-bordered focus:outline-none uppercase ml-2`}
                value={selectedDate}
                onChange={handleChangeDate}
              />
            </div>
          ) : (
            ""
          )}
          <div className="flex gap-3 w-full justify-center">
            <button
              className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
              onClick={() => cancelRequest()}
            >
              <p>Submit</p>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
